import { useCallback } from "react";
import apiClient from "../utils/axiosClient";

// fire-and-forget PATCH so backend knows the user opened Demand Studio
const useMarkDemandStudioOpened = (caseId) => {
  const markOpened = useCallback(() => {
    if (!caseId) return;
    apiClient.patch(`/api/case/${caseId}/opened-demand-studio`).catch(() => {});
  }, [caseId]);

  return markOpened;
};

export default useMarkDemandStudioOpened;
